
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M256 12.75l-11.5 35.7-48.4 149.65H0l158.7 115.6-59.9 185.55L256 384.75l157.2 114.5-59.9-185.55L512 198.1H315.9zm0 79l42.15 130.55h139.4l-112.8 82.15L367.1 435.6 256 354.55 144.9 435.6l42.35-131.15-112.6-82.15h139.2z","fill":"currentColor"}})])
      }
    
      }
    